import { treaty } from "@elysiajs/eden";
const eden = treaty("");
//Exports types shared to the frontend
export const MerklApi = (treaty);
